import React from 'react'

const PauseVideoIcon = ({
  width = 48,
  height = 48,
  color = 'currentColor',
  className = '',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    fill={color}
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path d="M12 9C12 7.9 12.9 7 14 7H20C21.1 7 22 7.9 22 9V39C22 40.1 21.1 41 20 41H14C12.9 41 12 40.1 12 39V9ZM26 9C26 7.9 26.9 7 28 7H34C35.1 7 36 7.9 36 9V39C36 40.1 35.1 41 34 41H28C26.9 41 26 40.1 26 39V9Z" />
  </svg>
)

export default PauseVideoIcon
